import { render, staticRenderFns } from "./BdrCallTraining.vue?vue&type=template&id=138b4ea7&scoped=true"
import script from "./BdrCallTraining.vue?vue&type=script&lang=js"
export * from "./BdrCallTraining.vue?vue&type=script&lang=js"
import style0 from "./BdrCallTraining.vue?vue&type=style&index=0&id=138b4ea7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138b4ea7",
  null
  
)

export default component.exports